import request from '@/plugins/axios'

// 点位列表
export const apiPointList = (params: any) => request.get('/operating.group_welfare.pointShop/lists', { params })

// 活动投放点位列表
export const apiActivityPointList = (params: any) => request.get('/operating.group_welfare.pointShop/activityPointLists', { params })

// 商家投放点位
export const apiShopPutLists = (params: any) => request.get('/operating.group_welfare.pointShop/shopPutLists', { params })

// 移除点位
export const apiDelPoint = (data: any) => request.post('/operating.group_welfare.pointShop/delPoint', data)

// 设置标签
export const apiSetTag = (data: any) => request.post('/operating.group_welfare.pointShop/setTag', data)

// 设置平台投放状态
export const apiSetPlatformPutStatus = (data: any) => request.post('/operating.group_welfare.pointShop/changePutStatus', data)

// 设置点位状态
export const apiSetStatus = (data: any) => request.post('/operating.group_welfare.pointShop/changeStatus', data)

// 分配点位
export const apiSetPoint = (data: any) => request.post('/operating.group_welfare.pointShop/setPoint', data)

// 分配供应商
export const apiSetSupplier = (data: any) => request.post('/operating.group_welfare.pointShop/setSupplier', data)

// 审核开通点位
export const apiAudit = (data: any) => request.post('/operating.group_welfare.pointShop/audit', data)

// 供应商列表
export const apiSupplierList = (params: any) => request.get('/operating.group_welfare.pointShop/suppliers', { params })

// 移除供应商
export const apiDelSupplier = (data: any) => request.post('/operating.group_welfare.pointShop/delSupplier', data)
